export default "__VITE_ASSET__BEhQXSvE__"